export default __webpack_public_path__ + "static/realWorldImg2-f3dc6977a40838cb7d6ef63165e61578.webp";